// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2O_8l","title":"Info_title__2tX_C","links":"Info_links__1_Z5s","link":"Info_link__DU3N8","logo":"Info_logo__1wLpK"};